/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ex } from './Ex';

class Order extends Ex {
    constructor() {
        super();
        this.baseUrl += '/order';
    }

    orderList(queryData) {
        let orderBeginTime = null;
        let orderEndTime = null;
        if (queryData.orderTime != null && queryData.orderTime.length === 2) {
            [orderBeginTime, orderEndTime] = queryData.orderTime;
        }
        let presellEndTimeBegin = null;
        let presellEndTimeEnd = null;
        if (queryData.presellEndTime != null && queryData.presellEndTime.length === 2) {
            [presellEndTimeBegin, presellEndTimeEnd] = queryData.presellEndTime;
        }
        let estimateShippingTimeBegin = null;
        let estimateShippingTimeEnd = null;
        if (queryData.estimateShippingTime != null && queryData.estimateShippingTime.length === 2) {
            [estimateShippingTimeBegin, estimateShippingTimeEnd] = queryData.estimateShippingTime;
        }
        return super.get('/orderList', {
            ...queryData,
            orderBeginTime,
            orderEndTime,
            presellEndTimeBegin,
            presellEndTimeEnd,
            estimateShippingTimeBegin,
            estimateShippingTimeEnd,
        });
    }

    getEstimateShippingTimeList(queryData) {
        let orderBeginTime = null;
        let orderEndTime = null;
        if (queryData.orderTime != null && queryData.orderTime.length === 2) {
            [orderBeginTime, orderEndTime] = queryData.orderTime;
        }
        let presellEndTimeBegin = null;
        let presellEndTimeEnd = null;
        if (queryData.presellEndTime != null && queryData.presellEndTime.length === 2) {
            [presellEndTimeBegin, presellEndTimeEnd] = queryData.presellEndTime;
        }
        let estimateShippingTimeBegin = null;
        let estimateShippingTimeEnd = null;
        if (queryData.estimateShippingTime != null && queryData.estimateShippingTime.length === 2) {
            [estimateShippingTimeBegin, estimateShippingTimeEnd] = queryData.estimateShippingTime;
        }
        return super.get('/getEstimateShippingTimeList', {
            ...queryData,
            orderBeginTime,
            orderEndTime,
            presellEndTimeBegin,
            presellEndTimeEnd,
            estimateShippingTimeBegin,
            estimateShippingTimeEnd,
        });
    }

    getOrderLodopPrintInfo(queryData) {
        let orderBeginTime = null;
        let orderEndTime = null;
        if (queryData.orderTime != null && queryData.orderTime.length === 2) {
            [orderBeginTime, orderEndTime] = queryData.orderTime;
        }
        let presellEndTimeBegin = null;
        let presellEndTimeEnd = null;
        if (queryData.presellEndTime != null && queryData.presellEndTime.length === 2) {
            [presellEndTimeBegin, presellEndTimeEnd] = queryData.presellEndTime;
        }
        let estimateShippingTimeBegin = null;
        let estimateShippingTimeEnd = null;
        if (queryData.estimateShippingTime != null && queryData.estimateShippingTime.length === 2) {
            [estimateShippingTimeBegin, estimateShippingTimeEnd] = queryData.estimateShippingTime;
        }
        return super.get('/getOrderLodopPrintInfo', {
            ...queryData,
            orderBeginTime,
            orderEndTime,
            presellEndTimeBegin,
            presellEndTimeEnd,
            estimateShippingTimeBegin,
            estimateShippingTimeEnd,
        });
    }

    getOrderExpressId(queryData) {
        let orderBeginTime = null;
        let orderEndTime = null;
        if (queryData.orderTime != null && queryData.orderTime.length === 2) {
            [orderBeginTime, orderEndTime] = queryData.orderTime;
        }
        let presellEndTimeBegin = null;
        let presellEndTimeEnd = null;
        if (queryData.presellEndTime != null && queryData.presellEndTime.length === 2) {
            [presellEndTimeBegin, presellEndTimeEnd] = queryData.presellEndTime;
        }
        let estimateShippingTimeBegin = null;
        let estimateShippingTimeEnd = null;
        if (queryData.estimateShippingTime != null && queryData.estimateShippingTime.length === 2) {
            [estimateShippingTimeBegin, estimateShippingTimeEnd] = queryData.estimateShippingTime;
        }
        return super.get('/getOrderExpressId', {
            ...queryData,
            orderBeginTime,
            orderEndTime,
            presellEndTimeBegin,
            presellEndTimeEnd,
            estimateShippingTimeBegin,
            estimateShippingTimeEnd,
        });
    }

    getDetail({ id }) {
        return super.get('/getDetail', { id });
    }

    cancelOrder({ id, cancelDesc }) {
        return super.post('/cancelOrder', { id, cancelDesc });
    }

    auditOrder({ ids, orderAuditStatus, auditOpinion }) {
        return super.post('/auditOrder', { ids, orderAuditStatus, auditOpinion });
    }

    completeOrder({ orderId }) {
        return super.post('/completeOrder', { orderId });
    }

    shippingOrder({ id, expressId, expressName, expressCode, trackingNumber }) {
        return super.post(
            '/shippingOrder',
            {
                id,
                expressId,
                expressName,
                expressCode,
                trackingNumber,
            },
            { timeout: 0 },
        );
    }

    batchShippingOrder({ ids, expressId }) {
        return super.post(
            '/batchShippingOrder',
            {
                ids,
                expressId,
            },
            {
                isHandleError: true,
                timeout: 0,
            },
        );
    }

    stockHandleOrder(params) {
        return super.post('/stockHandleOrder', params);
    }

    editOrderDeliveryInfo({
        id,
        deliveryConsignee,
        deliveryPhone,
        deliveryRegionId,
        deliveryAddress,
        deliveryIdCardNo,
    }) {
        return super.post('/editOrderDeliveryInfo', {
            id,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
            deliveryIdCardNo,
        });
    }

    editOrderComments({ id, orderComments }) {
        return super.post('/editOrderComments', { id, orderComments });
    }

    batchSyncErpOrder({ ids }) {
        return super.post('/batchSyncErpOrder', { ids }, { timeout: 0, isHandleError: true });
    }

    batchSyncErpOrderTrackingInfo({ ids }) {
        return super.post('/batchSyncErpOrderTrackingInfo', { ids }, { timeout: 0, isHandleError: true });
    }

    csOrderList({
        orderSnEq,
        deliveryPhoneEq,
        orderStatus,
        shipMethod,
        goodsType,
        trackingNumberEq,
        buyerMobileEq,
        currentPage,
        pageSize,
    }) {
        return super.get('/csOrderList', {
            orderSnEq,
            deliveryPhoneEq,
            orderStatus,
            shipMethod,
            goodsType,
            trackingNumberEq,
            buyerMobileEq,
            currentPage,
            pageSize,
        });
    }

    csStoreOrderList({ orderSnEq, buyerMobileEq, currentPage, pageSize }) {
        return super.get('/csStoreOrderList', {
            orderSnEq,
            buyerMobileEq,
            currentPage,
            pageSize,
        });
    }

    checkIdCard({ id, deliveryConsignee, deliveryIdCardNo, deliveryIdCardFront, deliveryIdCardBack }) {
        let deliveryIdCardFrontStr;
        if (deliveryIdCardFront) {
            deliveryIdCardFrontStr = deliveryIdCardFront
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        let deliveryIdCardBackStr;
        if (deliveryIdCardBack) {
            deliveryIdCardBackStr = deliveryIdCardBack
                .reduce((prev, curr) => {
                    prev.push(curr.name);
                    return prev;
                }, [])
                .join(',');
        }
        return super.post('/checkIdCard', {
            id,
            deliveryConsignee,
            deliveryIdCardNo,
            deliveryIdCardFront: deliveryIdCardFrontStr,
            deliveryIdCardBack: deliveryIdCardBackStr,
        });
    }

    findEnterpriseOrderList(queryData) {
        let paymentBeginTime = null;
        let paymentEndTime = null;
        if (queryData.paymentTime != null && queryData.paymentTime.length === 2) {
            [paymentBeginTime, paymentEndTime] = queryData.paymentTime;
        }
        return super.get('/findEnterpriseOrderList', {
            ...queryData,
            paymentBeginTime,
            paymentEndTime,
        });
    }

    findPersonalMemberOrderList(queryData) {
        let paymentBeginTime = null;
        let paymentEndTime = null;
        if (queryData.paymentTime != null && queryData.paymentTime.length === 2) {
            [paymentBeginTime, paymentEndTime] = queryData.paymentTime;
        }
        return super.get('/findPersonalMemberOrderList', {
            ...queryData,
            paymentBeginTime,
            paymentEndTime,
        });
    }

    findSubsidyOrderList(queryData) {
        let paymentBeginTime = null;
        let paymentEndTime = null;
        if (queryData.paymentTime != null && queryData.paymentTime.length === 2) {
            [paymentBeginTime, paymentEndTime] = queryData.paymentTime;
        }
        return super.get('/findSubsidyOrderList', {
            ...queryData,
            paymentBeginTime,
            paymentEndTime,
        });
    }

    getEnterpriseOrderDetail({ id }) {
        return super.get('/getEnterpriseOrderDetail', { id });
    }

    getPersonalMemberOrderDetail({ id }) {
        return super.get('/getPersonalMemberOrderDetail', { id });
    }

    getSubsidyOrderDetail({ id }) {
        return super.get('/getSubsidyOrderDetail', { id });
    }

    refundOrder({ id, refundAmount, refundDesc }) {
        return super.post('/refundOrder', { id, refundAmount, refundDesc });
    }

    findDeferredReviewOrderList(queryData) {
        let paymentBeginTime = null;
        let paymentEndTime = null;
        if (queryData.paymentTime != null && queryData.paymentTime.length === 2) {
            [paymentBeginTime, paymentEndTime] = queryData.paymentTime;
        }
        return super.get('/findDeferredReviewOrderList', {
            ...queryData,
            paymentBeginTime,
            paymentEndTime,
        });
    }

    getDeferredReviewOrderDetail({ id }) {
        return super.get('/getDeferredReviewOrderDetail', { id });
    }

    findSupplementOrderList(queryData) {
        let paymentBeginTime = null;
        let paymentEndTime = null;
        if (queryData.paymentTime != null && queryData.paymentTime.length === 2) {
            [paymentBeginTime, paymentEndTime] = queryData.paymentTime;
        }
        return super.get('/findSupplementOrderList', {
            ...queryData,
            paymentBeginTime,
            paymentEndTime,
        });
    }

    getSupplementOrderDetail({ id }) {
        return super.get('/getSupplementOrderDetail', { id });
    }
}

export default new Order();
export { Order };
